import { React, useEffect, useState, useRef } from 'react';
import { motion } from "framer-motion";
import GoToSimulation from '../../common/GoToSimulation';
import { rootRoute } from '../../../config';
import introduction from '../assets/introduction.png';
import step1_fc from '../assets/step1_fc.png';
import step2_fc from '../assets/step2_fc.png';
import step3_fc from '../assets/step3_fc.png';
import step4_fc from '../assets/step4_fc.png';
import step2fc_easy from '../assets/step2fc_easy.png';
import step3fc_easy from '../assets/step3fc_easy.png';
import step4fc_easy from '../assets/step4fc_easy.png';
import step2fc_medium from '../assets/step2fc_medium.png';
import step3fc_medium from '../assets/step3fc_medium.png';
import step4fc_medium from '../assets/step4fc_medium.png';
import { useOutletContext, useNavigate, useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import FcModuleStyle from '../styles/fc.module.css';

const Introduction = () => {
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location] = useOutletContext();
  const navigate = useNavigate();
  const [countAsWord, setCountAsWord] = useState('');
  const optionsAvailableLength = useRef(0);
  const initIntro = () => {
    setSimPopup(false);
    setIsOverlay(false);
    setHeaderPopup(false);
    setIsArtifacts(false);
  }
  const [currentSection, setCurrentSection] = useState(1);
  const handleContinueBtn = () => {
    if (currentSection <= 5) {
      setCurrentSection(currentSection + 1);
    }
  };
  const location = useLocation();
  const fuSkipWalkThruPopups = () => {
    let readStatusLength = simObj?.artifacts?.filter((artifact) => artifact.readstatus == 1).length;
    return (simObj?.currentstep > 0 || simObj?.attemptno > 1 || readStatusLength > 0 || simObj?.decisionHistory != null || simObj?.decisionHistory?.length != 0)
  }
  // const check_Location = () => { 
  //   const queryParams = new URLSearchParams(location.search);
  //   if (queryParams.has('from') && queryParams.get('from') == "footer") {
  //     navigate(`${rootRoute}/im`);
  //   } else {
  //     fuSkipWalkThruPopups() && navigate(`${rootRoute}/fc/simulation`);
  //   }
  // }
  useEffect(() => {
    initIntro();
    if (document.querySelector("footer.footer .container") != null) {
      if (fuSkipWalkThruPopups()) {
        document.querySelector("footer.footer .container").style.justifyContent = "center";
      }
    }
    if (document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro") != null) {
      if (fuSkipWalkThruPopups()) {
        document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "block";
      }
    }
    // if(document.querySelector(".continue-link") != null){
    //   if(fuSkipWalkThruPopups()){
    //     document.querySelector(".continue-link").style.justifyContent = "space-between";
    //   }
    // }
    if (document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").length > 0) {
      document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").forEach((item) => {
        item.style.display = "none"
      });
    }
    document.title = "Forecasting | Introduction";
    return () => {
      if (document.querySelector("footer.footer .container") != null) {
        document.querySelector("footer.footer .container").style.justifyContent = "space-between";
      }
      if (document.querySelector("footer.footer .footer-nav .footer-links li:not(.skip-intro)") != null) {
        document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").forEach((item) => {
          item.style.display = "block"
        });
      }
      if (document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro") != null) {
        document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "none";
      }
    }
  }, []);

  useEffect(() => {
    check_Location();
  }, [simObj]);

  useEffect(()=>{
    // debugger;
    if(simObj?.optionsAvailable){
      optionsAvailableLength.current = Object?.values(simObj?.optionsAvailable)?.reduce((a,b)=>a+b,0)
    }
  },[simObj?.optionsAvailable])

  useEffect(() => {
    const wordMap = {
      1: "one",
      2: "two",
      3: "three"
    };
    setCountAsWord(wordMap[optionsAvailableLength.current] || '');
  },[simObj])
  return (
    <motion.div className={`${FcModuleStyle.intro} ${FcModuleStyle.sections}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <div className={`${FcModuleStyle.section}`} style={{ display: currentSection >= 1 ? "block" : "none" }}>
        <div className={`ui stackable two column grid ${FcModuleStyle.ui} ${FcModuleStyle.stackable} ${FcModuleStyle.column} ${FcModuleStyle.grid}`}>
          <div className={`column ${FcModuleStyle.column}`}>
          <h2 className={`${FcModuleStyle['intro-heading']}`}>Introduction</h2>
          <h3 className={`${FcModuleStyle.situation}`}><strong>The Mission: </strong></h3>
            <div className={`${FcModuleStyle.content}`}>
              <p>{`You have taken up the role of an Operations Consultant and just signed a 2 year contract with a new client, PetroPlex, which is a gas station in your area.  As part of your role, you will provide monthly forecasts for PetroPlex to match customer demand. PetroPlex sells ${optionsAvailableLength.current} ${optionsAvailableLength.current === 1 ? "type" : "types"} of gas – ${(simObj?.optionsAvailable?.REGULAR && !simObj?.optionsAvailable?.MIDGRADE && !simObj?.optionsAvailable?.PREMIUM)? "Regular" : (simObj?.optionsAvailable?.REGULAR && simObj?.optionsAvailable?.MIDGRADE && !simObj?.optionsAvailable?.PREMIUM)?"Regular and Midgrade" :"Regular, Midgrade and Premium"}. You will need to provide accurate forecasts of the demand for the ${countAsWord} ${optionsAvailableLength.current === 1 ? "type" : "types"} of gasoline at the beginning of each month. Your goal is to keep the final MAPE after 2 years under ${simObj?.mapeToGoal}%.`}</p>
              <h3 className={`${FcModuleStyle.goal}`}><strong>Your Goal: </strong></h3>
              <p>Provide accurate forecasts with a collective Mean Average Percentage Error (MAPE) below {simObj?.mapeToGoal}%. Keep your MAPE below 10% and you'll earn a bonus.</p>
            </div>
          </div>
          <div className={`column ${FcModuleStyle.column}`}>
            <div className={`${FcModuleStyle.image}`}>
              <img src={introduction} alt="" />
            </div>
            <div className={`${FcModuleStyle.instr} ${FcModuleStyle.box}`}>
              <p className={`${FcModuleStyle.bgblue}`}>The simulation will take approximately <strong>20-45 minutes</strong> to complete and can be paused at any time.
              </p>
            </div>
          </div>
        </div>
        <hr aria-hidden="true" />
        <div
          className={`${FcModuleStyle['continue-link']}`}
          style={{ display: currentSection > 1 ? "none" : "flex" }}
        >
          {
            fuSkipWalkThruPopups() && <Link to={`${rootRoute}/fc/simulation`} className={`${FcModuleStyle['skip-intro']}`} role="button">
              <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
            </Link>
          }
          <a href="#step1" onClick={handleContinueBtn} role="button">
            {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
          </a>
        </div>
      </div>
      <div className={`${FcModuleStyle.section}`} style={{ display: currentSection >= 2 ? "block" : "none" }}>
        <div className={`${FcModuleStyle.step}`} id="step1">
          <div className={`ui stackable two column grid ${FcModuleStyle.ui} ${FcModuleStyle.stackable} ${FcModuleStyle.column} ${FcModuleStyle.grid}`}>
            <div className={`column ${FcModuleStyle.column}`}>
            <h2>Step 1: Review Documents</h2>
              <div className={`${FcModuleStyle.content}`}>
                <p>First, you will need to go through your incoming documents, email, chats and voice messages in order to familiarize yourself with the scenario specifics. Read these items carefully since they contain clues on how to best understand and solve problems. To begin forecasting, look for historical demand. Be sure to check new information which is indicated with an alert <span className={`${FcModuleStyle['red-circle']}`} aria-hidden="true" role='presentation'>2</span> <span className="sr-only">icon indicating 2 new items</span>.</p>
              </div>
            </div>
            <div className={`column ${FcModuleStyle.column}`}>
              <div className={`${FcModuleStyle.image}`}>
                <img src={step1_fc} alt="An image displays a webpage with an open email dialog box, along with a phone and messages icon and a list of multiple emails visible on the page." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${FcModuleStyle['continue-link']}`}
            style={{ display: currentSection > 2 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/fc/simulation`} className={`${FcModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step2" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${FcModuleStyle.section}`} style={{ display: currentSection >= 3 ? "block" : "none" }}>
        <div className={`${FcModuleStyle.step}`} id="step2">
          <div className={`ui stackable two column grid ${FcModuleStyle.ui} ${FcModuleStyle.stackable} ${FcModuleStyle.column} ${FcModuleStyle.grid}`}>
            <div className={`column ${FcModuleStyle.column}`}>
              <h2>Step 2: Make a Decision</h2>
              <div className={`${FcModuleStyle.image}`}>
                <img src={((optionsAvailableLength?.current == 1) && (simObj?.hasOwnProperty("version") && simObj?.version > 1)) ? step2fc_easy :((optionsAvailableLength?.current == 2) && (simObj?.hasOwnProperty("version") && simObj?.version > 1)) ? step2fc_medium : step2_fc} alt="An image displays a section of a webpage with Current Decision tab selected under make a forecast section, along Past decision tabs not selected and Ask AI with answer button." />
              </div>
            </div>
            <div className={`column ${FcModuleStyle.column}`}>
              <div className={`${FcModuleStyle.content}`}>
                <p>{`Next, you will have to make your first forecasting decision and anticipate the demand for each of the ${countAsWord} ${optionsAvailableLength.current === 1 ? "type" : "types"} of gasoline. Make sure to review all of your materials so that you can make the best decisions. You will have to supply a forecast at the beginning of every month for the two year period (24 months total).`}</p>
              </div>
            </div>

          </div>
          <hr aria-hidden="true" />
          <div
            className={`${FcModuleStyle['continue-link']}`}
            style={{ display: currentSection > 3 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/fc/simulation`} className={`${FcModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step3" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${FcModuleStyle.section}`} style={{ display: currentSection >= 4 ? "block" : "none" }}>
        <div id="step3" className={`${FcModuleStyle.step}`}> 
          <div className={`ui stackable two column grid ${FcModuleStyle.ui} ${FcModuleStyle.stackable} ${FcModuleStyle.column} ${FcModuleStyle.grid}`}>
            <div className={`column ${FcModuleStyle.column}`}>
              <h2>Step 3: Track Demand and Error</h2>
              <div className={`${FcModuleStyle.content}`}>
                <p>After submitting your first forecast, the simulation will begin running. Each ‘month’ in the simulation takes approximately 6 seconds. Every month charts will update to let you know how your forecast compares to actual demand, so you know how well you're doing.</p>
              </div>
            </div>
            <div className={`column ${FcModuleStyle.column}`}>
              <div className={`${FcModuleStyle.image}`}>
                <img src={(optionsAvailableLength?.current == 1) ? step3fc_easy :(optionsAvailableLength?.current == 2) ? step3fc_medium : step3_fc} alt="Track demand and error using demand graph, APE graph and tracking signal graph." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${FcModuleStyle['continue-link']}`}
            style={{ display: currentSection > 4 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/fc/simulation`} className={`${FcModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step4" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${FcModuleStyle.section}`} style={{ display: currentSection >= 5 ? "block" : "none" }}>
        <div id="step4" className={`${FcModuleStyle.step}`}>
          <div className={`ui stackable two column grid ${FcModuleStyle.ui} ${FcModuleStyle.stackable} ${FcModuleStyle.column} ${FcModuleStyle.grid}`}>
            <div className={`column ${FcModuleStyle.column}`}>
              <h2>Step 4: Watch Your Status</h2>
              <div className={`${FcModuleStyle.content}`}>
                <p>The Mean Absolutely Percentage Error meter, located in the top left of the screen, is there to help you judge how well you are doing against your main goal. To get a contract renewal you should keep your MAPE under {simObj?.mapeToGoal}%. You can also earn a bonus if you keep your MAPE under 10%. Check this meter often to make sure you're on track for success.</p>
              </div>
            </div>
            <div className={`column ${FcModuleStyle.column}`}>
              <div className={`${FcModuleStyle.image}`}>
                <img src={(optionsAvailableLength?.current == 1) ? step4fc_easy :(optionsAvailableLength?.current == 2) ? step4fc_medium : step4_fc} alt="Mean absolute percentage error meter." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${FcModuleStyle['continue-link']}`}
            style={{ display: currentSection > 5 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/fc/simulation`} className={`${FcModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#cardSec" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div style={{ display: currentSection >= 6 ? "block" : "none" }}>
        <div className="key-to-succ-sec">
          <div className={`${FcModuleStyle.bggray}`} id="cardSec">
            <div className={`${FcModuleStyle['keys-to-succ']}`}>
              <div style={{ "paddingTop": "20px" }}>
                <h2 className={`${FcModuleStyle['card-heading']}`}>Keys to Success</h2>
              </div>
              <div className={`${FcModuleStyle['card-wrapper']}`}>
                <div className={`ui card ${FcModuleStyle.ui} ${FcModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${FcModuleStyle.header} ${FcModuleStyle.aligned}`}>
                      <h3>Stay Informed</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${FcModuleStyle.content} ${FcModuleStyle.aligned}`}>
                    Your decisions are only as good as the information they are based on. Pay attention to indicators and read new messages as they come in.
                  </p>
                </div>

                <div className={`ui card ${FcModuleStyle.ui} ${FcModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${FcModuleStyle.header} ${FcModuleStyle.aligned}`}>
                      <h3>Be Adaptable</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${FcModuleStyle.content} ${FcModuleStyle.aligned}`}>
                    This simulation puts the course concepts into a real-world context where circumstances are changing. Don’t be afraid to make decisions when necessary.
                  </p>
                </div>

                <div className={`ui card ${FcModuleStyle.ui} ${FcModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${FcModuleStyle.header} ${FcModuleStyle.aligned}`}>
                      <h3>Be Patient</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${FcModuleStyle.content} ${FcModuleStyle.aligned}`}>
                    Sometimes the best course of action is to see how your decisions play out over longer time periods.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="section">
          <GoToSimulation />
        </div>
      </div>
    </motion.div>
  )
}

export default Introduction